import { Injectable } from "@angular/core";
import { PassingControlClient } from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class PassingControlService {
  constructor() {}

  passingControlByProductId(
    productId: number,
    channelRequestId: string,
  ): Promise<boolean> {
    return new PassingControlClient().product(productId, channelRequestId);
  }
}
